import JSR from 'mm-jsr';
import Vue from 'vue';

export default function () {
  const calculator = document.querySelectorAll('.calculator');

  if (calculator && calculator.length) {
    [].slice.call(calculator).forEach((elem) => {
      const objectName = elem.getAttribute('data-object');
      const object = window[`${objectName}`];

      new Vue({
        el: elem,
        delimiters: ['${', '}}'],
        components: {},
        data() {
          return {
            object,
            banks: object.banks.slice(0, 5),
            showAll: true,
            currency: '₽',
            currentType: 'a',
            prices: [
              +object.fields[0].value,
              +object.fields[1].value,
              +object.fields[2].value,
            ],
            jsr: [],
            calculator: {
              PRICE: +object.fields[0].value || 0,
              PRICE_FIRST: +object.fields[1].value || 0,
              TIME: +object.fields[2].value || 1,
              PERCENT: +object.fields[3].value || 8,
              CREDIT: 0,
              MONTHLY_BET: 0,
              COMMON_BET: 0,
              MONTHLY_PAY: 0,
              OVERPAY: 0,
              TOTAL: 0,
            },
          };
        },
        methods: {
          showBanks() {
            this.banks = this.banks.concat(this.object.banks.slice(5));
            if (this.object.banks.length === this.banks.length) {
              this.showAll = false;
            }
          },
          switchCurrency(event, index) {
            if (this.currency !== event.target.textContent) {
              this.currency = event.target.textContent;
              this.object.fields.forEach((field) => {
                if (field.currency) {
                  field.currency.forEach((currency) => {
                    if (currency.active) {
                      currency.active = false;
                    }
                  });
                  field.currency[index].active = true;
                }
              });
              const strText = this.$refs.itemmax[1].textContent;
              this.$refs.itemmax[1].textContent = strText
                .slice(0, strText.length - 1) + this.currency;
              window.calculatorPopupData = {
                'Стоимость недвижимости': `${this.calculator.PRICE} ${this.currency}`,
                'Первоначальный взнос': `${this.calculator.PRICE_FIRST} ${this.currency}`,
                'Срок ипотеки': this.calculator.TIME,
                'Процентная ставка': `${this.calculator.PERCENT} %`,
                'Сумма кредита': `${this.calculator.CREDIT} ${this.currency}`,
                'Ежемесячный платеж': `${this.calculator.MONTHLY_PAY} ${this.currency}`,
              };
            }
          },
          onInput(event, index) {
            this.setInputVal(index);
          },
          setInputVal(index) {
            if (index === 1 && this.prices[1] > this.prices[0]) {
              const firstprice = this.prices[0];
              this.prices[1] = firstprice;
            }
            this.prices[index] = this.prices[index].toString().replace(/\s/g, '');
            this.prices[index] = this.prices[index].replace(/[^0-9]/g, '');
            this.prices[index] = this.prices[index].replace(/(\w)(?=(\w{3})+(?!\w))/g, '$1 ');
          },
          inputChange(event, index) {
            event.target.value = event.target.value.replace(/\s/g, '');
            event.target.value = Number(event.target.value.replace(',', '.'));
            if (this.jsr[index]) {
              if (+event.target.value < +event.target.dataset.min) {
                this.jsr[index].setValue(0, +event.target.dataset.min);
              } else if (+event.target.value > +event.target.dataset.max) {
                this.jsr[index].setValue(0, +event.target.dataset.max);
              } else {
                this.jsr[index].setValue(0, +event.target.value);
              }
            } else if (event.target.hasAttribute('data-percent')) {
              if (+event.target.value <= 3) {
                event.target.value = 3;
              } else if (+event.target.value > 100) {
                event.target.value = 100;
              }
            }
            this.updatePrice(index, +event.target.value);
            this.calculateValues();
            this.prices[index] = event.target.value.replace(/(\w)(?=(\w{3})+(?!\w))/g, '$1 ');
            if (this.jsr[index]) {
              if (Number(this.prices[index].toString().replace(/\s/g, '')) > this.jsr[index].config.max) {
                this.prices[index] = this.jsr[index].config.max.toString().replace(/(\w)(?=(\w{3})+(?!\w))/g, '$1 ');
              }
              if (Number(this.prices[index].toString().replace(/\s/g, '')) < this.jsr[index].config.min) {
                this.prices[index] = this.jsr[index].config.min.toString().replace(/(\w)(?=(\w{3})+(?!\w))/g, '$1 ');
              }
            }
          },
          calculateValues() {
            /* eslint-disable */
            this.calculator.CREDIT = +((this.calculator.PRICE - this.calculator.PRICE_FIRST).toFixed());
            this.calculator.MONTHLY_BET = +(this.calculator.PERCENT / 12 / 100);
            this.calculator.COMMON_BET = +(Math.pow((1 + this.calculator.MONTHLY_BET), (this.calculator.TIME * 12))).toFixed(2);
            this.calculator.MONTHLY_PAY = Math.round(((this.calculator.PRICE - this.calculator.PRICE_FIRST) * this.calculator.MONTHLY_BET * this.calculator.COMMON_BET)
              / (this.calculator.COMMON_BET - 1));
            this.calculator.OVERPAY = Math.round((this.calculator.MONTHLY_PAY * (this.calculator.TIME * 12)) - (this.calculator.PRICE - this.calculator.PRICE_FIRST));
            this.calculator.TOTAL = Math.round(this.calculator.OVERPAY + (this.calculator.PRICE - this.calculator.PRICE_FIRST) + this.calculator.PRICE_FIRST);
            window.calculatorPopupData = {
              'Стоимость недвижимости': `${this.calculator.PRICE} ${this.currency}`,
              'Первоначальный взнос': `${this.calculator.PRICE_FIRST} ${this.currency}`,
              'Срок ипотеки': this.calculator.TIME,
              'Процентная ставка': `${this.calculator.PERCENT} %`,
              'Сумма кредита': `${this.calculator.CREDIT} ${this.currency}`,
              'Ежемесячный платеж': `${this.calculator.MONTHLY_PAY} ${this.currency}`,
            };
            /* eslint-enable */
          },
          updatePrice(index, value) {
            switch (index) {
              case 0:
                this.calculator.PRICE = +value;
                break;
              case 1:
                this.calculator.PRICE_FIRST = +value;
                break;
              case 2:
                this.calculator.TIME = +value;
                break;
              default:
                this.calculator.PERCENT = +value;
                break;
            }
          },
        },
        filters: {
          priceFormat(value) {
            return String(value).replace(/(\w)(?=(\w{3})+(?!\w))/g, '$1 ');
          },
        },
        mounted() {
          this.showAll = this.object.banks.length > 5;
          this.calculateValues();
          this.object.fields.forEach((field, index) => {
            if (field.range && this.$refs.ranges && this.$refs.ranges[index]) {
              this.jsr.push(new JSR([this.$refs.ranges[index]], {
                sliders: 1,
                step: +field.range.step || 50000,
                min: +field.range.min || 0,
                max: +field.range.max || 950000,
                values: [+field.value],
                grid: false,
              }).addEventListener('update', (input, value) => {
                this.prices.splice(index, 1, +value);
                this.updatePrice(index, +value);
                this.calculateValues();
                this.setInputVal(index);
                this.$refs.itemmax.forEach((item) => {
                  const parent = item.closest('.calculator__filter-item');
                  const rangeSpace = parent.querySelector('.jsr_bar');
                  const rangeSlider = parent.querySelector('.jsr_slider');
                  if (rangeSpace && rangeSlider) {
                    rangeSpace.style.width = rangeSlider.style.left;
                  }
                });
                if (index === 0) {
                  this.jsr[1].refresh({
                    max: Number(this.prices[0].toString().replace(/\s/g, '')) + 1,
                  });
                  const newPrice = this.prices[0].toString().replace(/(\w)(?=(\w{3})+(?!\w))/g, '$1 ');
                  this.$refs.itemmax[1].innerHTML = `${newPrice} ${this.currency}`;
                }
              }));
            }
          });
          for (let i = 0; i < this.prices.length; i += 1) {
            this.setInputVal(i);
          }
          this.jsr[1].refresh({
            max: Number(this.prices[0].toString().replace(/\s/g, '')),
          });
          const newPrice = this.prices[0].toString().replace(/(\w)(?=(\w{3})+(?!\w))/g, '$1 ');
          this.$refs.itemmax[1].innerHTML = `${newPrice} ${this.currency}`;
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/calculator/calculator.js